function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRelationships = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.149,
    y: 0.881,
    width: 44,
    height: 44,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.496,25.646L20.201,37.508C20.729,38 21.425,38.274 22.149,38.274C22.873,38.274 23.569,38 24.097,37.508L36.802,25.646C38.939,23.656 40.149,20.865 40.149,17.947L40.149,17.539C40.149,12.624 36.598,8.434 31.754,7.625C28.547,7.091 25.285,8.138 22.993,10.431L22.149,11.274L21.305,10.431C19.013,8.138 15.75,7.091 12.544,7.625C7.7,8.434 4.149,12.624 4.149,17.539L4.149,17.947C4.149,20.865 5.358,23.656 7.496,25.646Z",
    style: {
      fill: "#00659d",
      fillRule: "nonzero"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRelationships);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/relationships.f0061b992f6674297ea39b472a0b00a0.svg";